"use client";

import React, { useState } from "react";
import FormKnowMoney from "./formKnowMoney";
import FormUnknowMoney from "./formUnknowMoney";
import FormStepTwo from "./formStepTwo";

function Form({
  sended,
  setSended,
  data,
  setData,
  files,
  setFiles,
  step,
  setStep,
  admin,
}) {
  const [activeMoney, setActiveMoney] = useState(0);
  const hostname = window.location.hostname;
  return (
    <div
      className={`border ${
        hostname === "creditos.sofia.com.co" ? "bg-richBlack" : "bg-primary"
      }  rounded-xl p-3 h-fit`}
    >
      {step === 0 ? (
        <>
          <p className=" text-center text-white text-3xl font-bold">
            REALIZA TU SIMULACIÓN
          </p>

          {activeMoney === 0 ? (
            <FormKnowMoney setStep={setStep} setData={setData} data={data} />
          ) : (
            <FormUnknowMoney setStep={setStep} setData={setData} data={data} />
          )}
        </>
      ) : (
        <div className="bg-white rounded-xl p-3">
          <FormStepTwo
            setActiveMoney={setActiveMoney}
            activeMoney={activeMoney}
            setStep={setStep}
            setData={setData}
            data={data}
            files={files}
            setFiles={setFiles}
            sended={sended}
            setSended={setSended}
            admin={admin}
          />
        </div>
      )}
    </div>
  );
}

export default Form;
